import Vue from 'vue'
import Router from 'vue-router'
import Index from '../index/index.vue'
import VideoPlayback from '../index/VideoPlayback.vue'
import TextDetail from '../index/textDetail.vue'
import VideoDetail from '../index/videoDetail.vue'
import examination from '../index/examination.vue'
import Layout from '../index/base.vue'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'index',
			component: Index
		},
		{
			path: '/textDetail',
			component: Layout,
			children:[{
				path:'textDetail',
				name: 'textDetail',
				component: TextDetail,
				meta:{
					index:1,
					keepAlive:true
				}
			}]
		},
		{
			path: '/videoDetail',
			component: Layout,
			children:[{
				path:'videoDetail',
				name: 'videoDetail',
				component: VideoDetail,
				meta:{
					index:2,
					keepAlive:true
				}
			}]
		},
		{
			path: '/VideoPlayback',
			component: Layout,
			children:[
				{
					path:'VideoPlayback',
					name:'VideoPlayback',
					component:VideoPlayback
				}
			]
		},
		{
			path: '/examination',
			component: Layout,
			children:[
				{
					path:'examination',
					name:'examination',
					component:examination
				}
			]
		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js